import type { ListProviderProps } from "./list.type";
import type { PropsWithChildren } from "react";

import ListFetcher from "./list-fetcher";
import { ListContext } from "./list.context";
import { useListContextValues } from "./list.hook";

const ListProvider = ({
  children,
  ...props
}: PropsWithChildren<ListProviderProps>) => {
  const values = useListContextValues(props);

  return (
    <ListContext.Provider value={values}>
      <ListFetcher />
      {children}
    </ListContext.Provider>
  );
};

export default ListProvider;
